<template>
  <div class="roomList__addressBook">
    <add-address-book></add-address-book>

    
    <div class="roomList__addressBook__wrapper">
      <table class="table is-striped is-fullwidth addressBook__table">
        <thead>
          <tr>
            <th class="roomList__heading">STT</th>
            <th class="roomList__heading">Thiết bị</th>
            <th class="roomList__heading">Loại kết nối</th>
            <th class="roomList__heading">Thông tin cuộc gọi</th>
            <th class="roomList__heading">Chọn phòng họp</th>
          </tr>
        </thead>
        <tbody v-if="modifiedAddressBooks">
          <tr v-for="(addressBook, index) in modifiedAddressBooks" :key="addressBook._id">
            <td class="bg-grey">{{index+1}}</td>
            <td class="bg-grey">{{addressBook.device}}</td>
            <td class="bg-grey">{{addressBook.dialType}}</td>
            <td class="bg-grey">{{addressBook.dialInfo}}</td>
            <td class="bg-grey">
              <div class="field is-grouped is-grouped-multiline">
                <div class="control control-required">
                  <v-select class="address-book-select" label="roomIdentifier" :options="roomList" @input="(evt) => updateRoomByDevice(evt, index)"></v-select>
                </div>
                <div class="control">
                  <b-button
                    type="is-info"
                    @click="connectDevice(addressBook)"
                    class="roomList__btn-new"
                  >Kết nối</b-button>
                </div>
                <div class="control">
                  <b-button
                    type="is-danger"
                    @click="openDeleteDeviceModal(addressBook._id)"
                    class="roomList__btn-new"
                  >Xoá</b-button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <b-modal :active.sync="isDeleteDeviceModal">
      <div class="content-layout content-layout--passcode">
        <header class="modal-card-head"><p class="modal-card-title">Xoá thông tin</p><button aria-label="close" class="delete" @click="isDeleteDeviceModal=false"></button></header>
        <div class="content-layout__inner">
          <div class="body-text">Xin xác nhận xoá thông tin đã đăng ký?</div>
        </div>
        <div class="modal-bottom-group field is-grouped is-grouped-centered">
          <div class="control">
            <b-button @click="isDeleteDeviceModal=false">Đóng</b-button>
          </div>
          <div class="control">
            <b-button type="is-danger" @click="removeDevice">Xoá</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState, mapActions } from "vuex";
import vSelect from "vue-select"

Vue.component('v-select', vSelect)

export default {
  components: {
    AddAddressBook: () => import("./AddAddressBook")
  },
  created() {
    this.getAddressBook();
  },
  data() {
    return {
      phoneBooks: null,
      isDeleteDeviceModal: false,
      addressBookId: null,
      selectedAddress: null
    };
  },
  methods: {
    ...mapActions("room", [
      "getAddressBook",
      "setDialOut",
      "deleteAddressBook",
      "getConferenceIdList"
    ]),
    connectDevice(addressBook) {
      this.selectedAddress = addressBook
      const checkedStartRoom = this.startRoom(addressBook.selectedRoom)
      if(checkedStartRoom) {
        checkedStartRoom.then(() => {
          const searchedMeeting = this.$store.state.room.conferenceIdentityList.find(meeting => {
            return meeting.roomId === addressBook.selectedRoom.roomIdentifier
          })
          if (searchedMeeting) {
            this.setDialOut({
              name: addressBook.device,
              text: addressBook.dialInfo,
              type: addressBook.dialType,
              conferenceId: searchedMeeting.conferenceId
            }).then(res => {
              if (res.data.status) {
                this.$toast.open({
                  message: "Kết nối thành công",
                  type: "is-info"
                });
              } else {
                this.$toast.open({
                  type: "is-danger",
                  message: "Rất tiếc, vui lòng kiểm tra thông tin người dùng của bạn"
                });
              }
            }).finally(() => {
              this.selectedAddress = null
            });
          } else {
            this.$toast.open({
              type: "is-danger",
              message: "Phòng họp chưa được bắt đầu"
            });
          }
        })
      }
    },
    openDeleteDeviceModal(id) {
      this.isDeleteDeviceModal = true
      this.addressBookId = id
    },
    removeDevice() {
      this.deleteAddressBook(this.addressBookId).finally(() => {
        this.isDeleteDeviceModal = false
        this.addressBookId = null
      })
    },
    // manage joint participant, conference
    startRoom(room) {
      if(room) {
        const { roomIdentifier } = room;
        this.isLoadButtonStart = true;
        return this.$store
          .dispatch("room/startConference", roomIdentifier)
          .then(res => {
            if (res.data.status == 409) {
              return this.getConferenceIdList({roomIds: this.roomList.map(room => room.roomIdentifier)});
            } else {
              return res
            }
          })
          .finally(() => (this.isLoadButtonStart = false));
      } else {
        this.$toast.open({
          message: "Vui lòng chọn phòng họp để khởi động",
          type: "is-danger"
        });
        return null
      }
    },
    updateRoomByDevice(evt, index) {
      this.modifiedAddressBooks[index].selectedRoom = evt
    }
  },
  computed: {
    ...mapState("room", ["addressBooks", "roomList"]),
    modifiedAddressBooks() {
      return this.addressBooks ? this.addressBooks.map(addressBook => {
        addressBook.selectedRoom = null
        return addressBook
      }) : []
    }
  }
};
</script>

<style lang="scss" scope>
@import "vue-select/src/scss/vue-select.scss";
.roomList {
  &__addressBook {
    margin-top: 20px;

    &__wrapper {
      word-break: break-word;
    }
  }

  &__address-form {
    margin-left: 15px;
  }
}
.v-select {
  &.address-book-select {
    display: inline-block;
    vertical-align: middle;
    width: 125px;
    &.select-participant {
      width: 100%;
    }
  }
}
</style>